<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleManagementChartCard from './PostSaleManagementChartCard.vue';

const props = defineProps({
  dashboard: { type: Object, required: true },
  loading: { type: Boolean, default: false },
});
const emit = defineEmits(['viewFiltered']);

const { t } = useI18n();

const charts = computed(() => [
  {
    id: 'status',
    title: t('POST_SALE.MANAGEMENT.CHART.STATUS'),
    total: props.dashboard.prazo_status_andamento?.total || 0,
    items: [
      {
        key: 'em_dia',
        label: t('POST_SALE.MANAGEMENT.CHART.ON_TIME'),
        fill: 'fill-[#6B9539]',
        text: 'text-[#6B9539]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_ON_TIME'),
      },
      {
        key: 'em_alerta',
        label: t('POST_SALE.MANAGEMENT.CHART.ALERT'),
        fill: 'fill-[#CC8E00]',
        text: 'text-[#CC8E00]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_ALERT'),
      },
      {
        key: 'atrasados',
        label: t('POST_SALE.MANAGEMENT.CHART.OVERDUE'),
        fill: 'fill-[#E33838]',
        text: 'text-[#E33838]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_OVERDUE'),
      },
    ],
    values: props.dashboard.prazo_status_andamento || {},
  },
  {
    id: 'payments',
    title: t('POST_SALE.MANAGEMENT.CHART.PAYMENTS'),
    total: props.dashboard.forma_pagamento_andamento?.total || 0,
    items: [
      {
        key: 'avista',
        label: t('POST_SALE.MANAGEMENT.CHART.CASH'),
        fill: 'fill-[#14B8AA]',
        text: 'text-[#14B8AA]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_CASH'),
      },
      {
        key: 'financiamento',
        label: t('POST_SALE.MANAGEMENT.CHART.FINANCING'),
        fill: 'fill-[#01655D]',
        text: 'text-[#01655D]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_FINANCING'),
      },
      {
        key: 'FGTS',
        label: t('POST_SALE.MANAGEMENT.CHART.FGTS'),
        fill: 'fill-[#FF7A11]',
        text: 'text-[#FF7A11]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_FGTS'),
      },
      {
        key: 'consorcio',
        label: t('POST_SALE.MANAGEMENT.CHART.CONSORTIUM'),
        fill: 'fill-[#CC8E00]',
        text: 'text-[#CC8E00]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_CONSORTIUM'),
      },
    ],
    values: props.dashboard.forma_pagamento_andamento || {},
  },
  {
    id: 'laudemiums',
    title: t('POST_SALE.MANAGEMENT.CHART.LAUDEMIUMS'),
    total: props.dashboard.laudemios_andamento?.total || 0,
    items: [
      {
        key: 'prefeitura',
        label: t('POST_SALE.MANAGEMENT.CHART.CITY_HALL'),
        fill: 'fill-[#CD8FBC]',
        text: 'text-[#CD8FBC]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_CITY_HALL'),
      },
      {
        key: 'uniao',
        label: t('POST_SALE.MANAGEMENT.CHART.UNION'),
        fill: 'fill-[#4E79A7]',
        text: 'text-[#4E79A7]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_UNION'),
      },
      {
        key: 'igreja',
        label: t('POST_SALE.MANAGEMENT.CHART.CHURCH'),
        fill: 'fill-[#CE7456]',
        text: 'text-[#CE7456]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_CHURCH'),
      },
      {
        key: 'familia',
        label: t('POST_SALE.MANAGEMENT.CHART.FAMILY'),
        fill: 'fill-[#5C9055]',
        text: 'text-[#5C9055]',
        menu: t('POST_SALE.MANAGEMENT.CHART.ALL_FAMILY'),
      },
    ],
    values: props.dashboard.laudemios_andamento || {},
  },
]);
</script>

<template>
  <section class="flex flex-col gap-4">
    <h2 class="text-lg font-semibold text-lais-text">
      {{ t('POST_SALE.MANAGEMENT.CHART.IN_PROGRESS') }}
    </h2>

    <div v-if="loading" class="grid gap-4 xl:grid-cols-3">
      <div
        v-for="index in 3"
        :key="index"
        class="h-[27rem] animate-pulse rounded-lais border border-lais-border-soft bg-white"
      />
    </div>

    <div v-else class="grid gap-4 xl:grid-cols-3">
      <PostSaleManagementChartCard
        v-for="chart in charts"
        :key="chart.id"
        :chart="chart"
        @view-filtered="emit('viewFiltered', { type: chart.id, value: $event })"
      />
    </div>
  </section>
</template>
